/**
 * @summary util-helpers 版本号。
 * @since 4.18.0
 */
const VERSION = BUILD_VERSION;

export default VERSION;
